import { ApprovalConsiderationAnnounceElevenContainer } from '../../../containers/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceElevenContainer';
export function ApprovalConsiderationAnnounceElevenPage() {
    return (
        <ApprovalConsiderationAnnounceElevenContainer />
    )
}